import seedrandom from "seedrandom";
import { DateTime } from "luxon";
import { brandles } from "../constants";

const FILTERS_COUNT = 7;

export const getCurrentGameIndex = (currentDate: DateTime) => {
  // const currentDate: DateTime = DateTime.now();
  const currentDateString: string = `${currentDate.month}/${currentDate.day}`;

  const startDay: DateTime = DateTime.fromFormat("2022-06-14", "yyyy-MM-dd");
  const brand = brandles.brands.find((item) => item.date === currentDateString);

  const pickedFilter = Math.floor(
    seedrandom.alea(currentDateString)() * FILTERS_COUNT+1
  );
  // const pickedFilter = 7;

  const pickedBrand = brand?.id;
  const gameNumber = Math.ceil(currentDate.diff(startDay, "day").days);

  return { pickedBrand, gameNumber, pickedFilter };
};

export const filter7 = () => {
  const currentDate: DateTime = DateTime.now();
  const currentDateString: string = `${currentDate.month}/${currentDate.day}`;

  let initArray = Array(100).fill(1);
  let blankArray = Array(100).fill(0);
  let indexesArray: number[] = [];  

  const filter7Steps: Record<string, number[]> = {
    step1: [],
    step2: [],
    step3: [],
    step4: [],
    step5: [],
    step6: blankArray,
  };

  for (let i = 0; i < 61; i++) {
    indexesArray = initArray.reduce((acc, item, index) => {
      if (item === 1) {
        acc.push(index);
      }
      return acc;
    }, [] as number[]);

    const seed = `${indexesArray.length}${currentDateString}${i}`;
    const pickedIndex = Math.floor(
      seedrandom.alea(seed)() * indexesArray.length
    );

    initArray[indexesArray[pickedIndex]] = 0;

    switch (i) {
      case 10:
        filter7Steps.step1 = initArray.slice();
        break;
      case 20:
        filter7Steps.step2 = initArray.slice();
        break;
      case 30:
        filter7Steps.step3 = initArray.slice();
        break;
      case 40:
        filter7Steps.step4 = initArray.slice();
        break;
      case 60:
        filter7Steps.step5 = initArray.slice();
    }
  }

  return { filter7Steps };
};

export const randomGreyHex = (seed1: number, seed2: number) => {
  const currentDate: DateTime = DateTime.now();
  const currentDateString: string = `${currentDate.month}/${currentDate.day}`;
  const seed = `${seed1}${currentDateString}${seed2}`;

  const v = ((seedrandom.alea(seed)() * 256) | 0).toString(16); //bitwise OR. Gives value in the range 0-255 which is then converted to base 16 (hex).
  return "#" + v + v + v;
};
